import { phone, email, pdfCommissions, pdfTraining1 } from '@/config'

const contacts = {
  whatsapp1: '254740023671'
}

const referralLink = 'https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fke%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.co.ke%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral'

const dashboardGetUpdatedItems = [
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      key: 'dashboard.media.facebook_group'
    },
    link: 'https://www.facebook.com/profile.php?id=100015174757922',
    newPage: true
  },
  {
    disabled: true,
    img: 'img/dashboard/comingSoon.svg',
    title: {
      key: 'dashboard.media.jforce_blog'
    },
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
   {
    img: 'img/dashboard/contact-form.svg',
    title: {
      key: 'dashboard.claim_form.title'
    },
    subtitle: {
      text: 'through this claim form',
      isKey: false
    },
    link: 'https://docs.google.com/forms/d/1mEQz8Wu9IQTD03_AXezG5ePayI1fS83_mkrYgKtX9Ec/edit',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-facebook.svg',
    title: {
      text: 'Join us on Facebook'
    },
    link: 'https://www.facebook.com/profile.php?id=61550214365264&mibextid=9R9pXO',
    newPage: true
  },
]

const dashboardOtherItems = [
  {
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      text: 'Commission grid & levels'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'Training'
    },
    link: pdfTraining1,
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
